import { useOverviewRuntime } from '../../context'
import TileWrapper from '../TileWrapper'

const GuildMessageTile = () => {
  const { guildMotd } = useOverviewRuntime()

  return (
    <TileWrapper>
      <p className='whitespace-pre-wrap'>
        {guildMotd || (
          <span className='text-muted-foreground'>No message set.</span>
        )}
      </p>
    </TileWrapper>
  )
}
export default GuildMessageTile
